<script lang="ts">
  import { untrack } from 'svelte';
  import { api } from '../../api/client';
  import Modal from '../Modal.svelte';
  import { calendar, TILES, tileName, type TileId, type Tiles } from '../../utils/insights';
  import { t } from '../../i18n/index.ts';

  // TileEditor chooses and orders the member's tiles, at least one; the
  // choice is kept on the server so the apps show the same (spec 006
  // 006 FR-080).
  let { tiles, onsaved, onclose }: { tiles: TileId[]; onsaved: (t: Tiles) => void; onclose: () => void } = $props();

  // The list starts from the tiles as they were when opened.
  let chosen = $state<TileId[]>(untrack(() => [...tiles]));
  let error = $state('');

  function move(i: number, by: number) {
    const next = [...chosen];
    [next[i], next[i + by]] = [next[i + by], next[i]];
    chosen = next;
  }

  async function save() {
    try {
      onsaved(await api.put<Tiles>(`/me/tiles?${calendar()}`, { tiles: chosen }));
    } catch (e: any) {
      error = e.message;
    }
  }
</script>

<Modal title={t('activitiesTilesEdit')} {onclose}>
  <div class="space-y-4">
    <ol class="space-y-1">
      {#each chosen as id, i (id)}
        <li class="flex items-center gap-2">
          <span class="flex-1">{tileName(id)}</span>
          <button class="btn btn-secondary btn-sm" aria-label={t('activitiesTilesMoveUp', { tile: tileName(id) })} disabled={i === 0} onclick={() => move(i, -1)}><i aria-hidden="true" class="las la-arrow-up"></i></button>
          <button class="btn btn-secondary btn-sm" aria-label={t('activitiesTilesMoveDown', { tile: tileName(id) })} disabled={i === chosen.length - 1} onclick={() => move(i, 1)}><i aria-hidden="true" class="las la-arrow-down"></i></button>
          <button class="btn btn-secondary btn-sm" aria-label={t('activitiesTilesRemove', { tile: tileName(id) })} disabled={chosen.length === 1} onclick={() => (chosen = chosen.filter((x) => x !== id))}><i aria-hidden="true" class="las la-times"></i></button>
        </li>
      {/each}
    </ol>
    {#if chosen.length < TILES.length}
      <div>
        <h3 class="text-sm font-medium mb-1">{t('activitiesTilesAdd')}</h3>
        <div class="flex flex-wrap gap-2">
          {#each TILES.filter((tile) => !chosen.includes(tile.id)) as tile (tile.id)}
            <button class="btn btn-secondary btn-sm" onclick={() => (chosen = [...chosen, tile.id])}><i aria-hidden="true" class="las la-plus mr-1"></i>{tile.name}</button>
          {/each}
        </div>
      </div>
    {/if}
    {#if error}
      <p class="text-sm" style="color: var(--theme-error);">{error}</p>
    {/if}
    <div class="flex justify-end gap-2">
      <button class="btn btn-secondary" onclick={onclose}>{t('appCancel')}</button>
      <button class="btn btn-primary" onclick={save}>{t('appSave')}</button>
    </div>
  </div>
</Modal>
